export type TopVisibleAnchor = {
  eventId: number
  offsetPx: number
}

export const findTopVisibleAnchor = (container: HTMLElement): TopVisibleAnchor | undefined => {
  const containerRect = container.getBoundingClientRect()
  let topAnchor: TopVisibleAnchor | undefined

  container.querySelectorAll('.chat-event-list-item[data-event-id]').forEach((node) => {
    const eventIdAttr = node.getAttribute('data-event-id')
    if (!eventIdAttr) {
      return
    }

    const eventId = Number.parseInt(eventIdAttr, 10)
    if (Number.isNaN(eventId)) {
      return
    }

    const rect = node.getBoundingClientRect()
    if (rect.bottom <= containerRect.top || rect.top >= containerRect.bottom) {
      return
    }

    const offsetPx = rect.top - containerRect.top
    if (!topAnchor || offsetPx < topAnchor.offsetPx) {
      topAnchor = { eventId, offsetPx }
    }
  })

  return topAnchor
}
